import { Component, Input, OnInit, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';

@Component({
    selector: 'app-jobs-table',
    templateUrl: './jobs-table.component.html',
    styleUrls: ['./jobs-table.component.scss'],
    standalone: true,
    imports: [CommonModule, MatTableModule]
})
export class JobsTableComponent implements OnInit {
  @Input() jobsList: any;
  @Input() view: string = 'normal';
  @Input() disableDetails: boolean = false;
  @Input() internal: boolean = false;
  jobsDatasource: MatTableDataSource<any>;
  selectedJob: any;

  jobColumns = ['company_name', 'title', 'started_at', 'ended_at', 'created'];

  constructor() {}

  lagClass(lag: number | null | undefined): string {
    if (lag === null || lag === undefined) return '';
    if (lag <= 3) return 'tw-text-green-600 dark:tw-text-green-400';
    if (lag <= 6) return 'tw-text-yellow-600 dark:tw-text-yellow-400';
    return 'tw-text-red-600 dark:tw-text-red-400';
  }

  dateFormat(yearOnly: boolean): string {
    if (this.internal) {
      return yearOnly ? "''yy" : "MMM ''yy";
    }
    return yearOnly ? 'yyyy' : 'MMM yyyy';
  }

  ngOnInit(): void {
    this.updateData();
  }

  ngOnChanges(): void {
    this.updateData();
  }

  private updateData(): void {
    const now = new Date().getTime();

    // if( this.view === 'compact' ) {
    //   this.jobColumns.splice(this.jobColumns.indexOf('created'), 1);
    // }

    if (this.jobsList) {
      let jobsToShow = this.jobsList
        .map((j: any) => {
          j['newly_created'] = new Date(j.created_at).getTime() > now - 1000 * 60 * 60 * 24;
          return j;
        })
        .sort((a: any, b: any) => b.ordering - a.ordering);

      if (this.view === 'compact') {
        jobsToShow = jobsToShow.slice(0, 5);
      }
      this.jobsDatasource = new MatTableDataSource(jobsToShow);
    }
  }
}
